import { connect } from 'react-redux'
import View from './SearchToggle'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const SearchToggle = connect(mapStateToProps)(View)

export default SearchToggle
